module.exports = __webpack_public_path__ + "static/media/documento-icon.e85d93f9.svg";